import { render, staticRenderFns } from "./BatchDiagnose.vue?vue&type=template&id=156f5aa9"
import script from "./BatchDiagnose.vue?vue&type=script&lang=js"
export * from "./BatchDiagnose.vue?vue&type=script&lang=js"
import style0 from "./BatchDiagnose.vue?vue&type=style&index=0&id=156f5aa9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports